import React, { useState } from 'react';
import SettingsSidebar from './SettingsSidebar';
import ProfileSettings from './ProfileSettings';

const Settings = () => {
  const [activeSection, setActiveSection] = useState('profile');

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return <ProfileSettings />;
      default:
        return <ProfileSettings />;
    }
  };

  return (
    <div>
      <SettingsSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      {renderContent()}
    </div>
  );
};

export default Settings;
